export default __webpack_public_path__ + "static/media/dummy-google-workspace-single.5523599e.png";